<app-offers-container
  *ngIf="(offers$ | async).offer"
  [offers]="offers$ | async"
></app-offers-container>
